import React, { useState } from "react";
import { AddProspect } from "../../pages";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { BusinessController } from "../../controllers";
import { phoneRegExp, removeEmptyKeys } from "../../utils/utils";
import * as yup from "yup";

const AddProspectContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    fullname: yup
      .string()
      .required("Full Name is required")
      .min(2, "Full Name must be at least 2 characters")
      .max(100, "Full Name must not exceed 100 characters"),

    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),

    mobile: yup
      .string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Mobile is required"),

    gender: yup.string().required("Gender is required"),
    tag: yup.string().required(),
    description: yup
      .string()
      .required()
      .max(100, "Description must not exceed 100 characters"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      fullname: values.fullname,
      email: values.email,
      mobile: values.mobile,
      gender: values.gender,
      tag: values.tag,
      platform: values.platform,
      description: values.description,
    };

    removeEmptyKeys(payload);

    const { status, errorMessage } =
      await BusinessController.createProspect(payload);
    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
      closeModal();

      return;
    }
    setLoading(false);
    return MimaToastUtil.error({
      message: errorMessage,
    });
  };
  return (
    <AddProspect
      closeModal={closeModal}
      onSubmit={onSubmit}
      loading={loading}
      validationSchema={validationSchema}
    />
  );
};

export default AddProspectContainer;
